import api from "./api";

// StatusSolicitacao: 0 Nova · 1 EmContato · 2 Convertida · 3 Descartada
export const STATUS_SOLICITACAO = {
  Nova: 0,
  EmContato: 1,
  Convertida: 2,
  Descartada: 3,
};

export const STATUS_SOLICITACAO_LABEL = {
  0: "Nova",
  1: "Em contato",
  2: "Convertida",
  3: "Descartada",
};

export async function listSolicitacoes(status) {
  const params = status != null ? { status } : undefined;
  const { data } = await api.get("/Solicitacoes", { params });
  return data;
}

export async function getSolicitacoesCounts() {
  const { data } = await api.get("/Solicitacoes/counts");
  return data;
}

export async function updateSolicitacaoStatus(id, status) {
  await api.put(`/Solicitacoes/${id}/status`, { status });
}

export async function deleteSolicitacao(id) {
  await api.delete(`/Solicitacoes/${id}`);
}
